import ReactModal from "react-modal";
import { SERVER_IP } from "../../../static/server";

const agree1 = ({ isAgree1pdf, setAgree1pdf, setAgree1 }) => {
  let hostURL = window.location.host;

  return (
    <ReactModal
      isOpen={isAgree1pdf}
      style={{
        overlay: {
          background: "rgba(0, 0, 0, 0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        content: {
          inset: 0,
          // padding: 0,
          background: "white",
          // overflowY: "auto",
          position: "relative",
          // border: "1px solid #ccc",
          borderRadius: "0.3rem",
          alignItems: "center",
          height: "80%",
          width: "80%",
        },
      }}
    >
      <div className="base-sec">
        <div className="background-color-w">
          <div className="base-sec-top flex">
            <div>
              <p>전문보기</p>
            </div>
            <div>
              <button
                className="close"
                onClick={() => {
                  setAgree1pdf(false);
                }}
              ></button>
            </div>
          </div>
          <div style={{ height: "100vh", width: "100%",overflow: "hidden", display: "flex", justifyContent: "center", alignItems: "center"}}>
            <iframe
              // src="http://localhost:3001/media/agree/agree1.pdf"
              src={`${SERVER_IP}/media/agree/agree1.pdf`}
              width="100%"
              height="100%"
            ></iframe>
          </div>
          <div className="base-sec-sec"></div>
          <div className="base-sec-bottom">
            <button
              className="sign-insert c-btn"
              type="button"
              onClick={() => {
                setAgree1pdf(false);
                setAgree1(true);
              }}
            >
              동의
            </button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};
export default agree1;
